<template>
    <div class="municipalities-list__item">
        <div>{{ municipality.geo_code }}</div>
        <div><a :href="municipality.url">{{ municipality.name }}</a></div>
    </div>
</template>

<script>

export default {
    name: 'municipalities-item',

    props: {
        municipality: {
            type: Object,
            required: true,
        },
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/municipalities-item.vue